export const ROOT_CLASS_NAME = `js-tags-wrapper`;
export const GROUP_CLASS_NAME = `js-tag-section`;
export const REMOVE_GROUP_CLASS_NAME = `js-remove-group`;
export const REMOVE_TAG_CLASS_NAME = `js-tag-remove`;
export const CREATE_TAG_CLASS_NAME = `js-create-tag`;
export const ADD_TAG_CLASS_NAME = `js-add-tag`;
export const EDIT_PROJECT_CLASS_NAME = `js-edit-projects`;
export const CLOSE_CLASS_NAME = `js-close`;
export const CONFIRM_REMOVE_CLASS_NAME = `js-confirm-remove`;
export const TAG_CLASS_NAME = `js-tag`;
export const TAG_LIST_CLASS_NAME = `js-tag-list`;
export const PROJECT_LIST_CLASS_NAME = `js-project-list`;
export const PROJECT_REMOVE_CLASS_NAME = `js-project-remove`;
export const CLEAR_CLASS_NAME = `js-reset-btn`;
export const RENAME_GROUP_CLASS_NAME = `js-group-rename`;
export const CREATE_GROUP_BTN_CLASS_NAME = `js-create-group`;
export const DEFAULT_TEMPLATE_CLASS_NAME = `js-default-section`;
export const WHITE_SPACE_EXP = /^\s+$/;

export const ActionUrl = {
  REMOVE_GROUP_URL: `/marker/delete-marker-group`, //`/data/remove-tag.json`,
  REMOVE_TAG_URL: `/marker/delete-marker`, //`/data/remove-tag.json`,
  REMOVE_TAG_FROM_TASK_URL: `marker/delete-task`, //`/data/remove-tag.json`,
  GET_PROJECTS_URL: `/marker/projects`, //`/data/projectList.json`,
  RENAME_GROUP_URL: `/marker/update-marker-group`, //`data/rename-group.json`,
  CREATE_GROUP_URL: `/marker/create-marker-group`, //`data/createTagGroup.json`,
  ADD_TAG_TO_TASK_URL: `marker/add-task`, //`data/add-tag.json`,
  CHANGE_PROJECT_URL: `/marker/project`, //`data/tags.json`,
};

export const TaskType = {
  ADD: `one-task`,
  CREATE: `create-task`,
};
